
interface GprofileErrorProps {
  error: string;
  onRetry: () => void;
  onBack: () => void;
}

const GprofileError = ({ error, onRetry, onBack }: GprofileErrorProps) => {
  console.log('❌ Showing error state:', error);
  
  return (
    <div className="min-h-screen bg-carbon flex items-center justify-center">
      <div className="text-center max-w-md px-4">
        <h2 className="text-xl font-bold text-toxic-green mb-2">Unable to Load Profile</h2>
        <p className="text-ice-white/70 mb-4">{error}</p>
        <div className="space-y-2">
          <button
            onClick={onRetry}
            className="w-full bg-neon-red hover:bg-neon-red/80 text-ice-white font-medium px-4 py-2 rounded-lg transition-colors"
          >
            Try Again
          </button>
          <button
            onClick={onBack}
            className="w-full text-toxic-green hover:text-toxic-green/80 underline"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default GprofileError;
